import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../config/axiosInstance";

/**
 * Empresa do usuário logado.
 *
 * `/companies/me` resolve pelo token e cria o rascunho quando o anunciante
 * ainda não preencheu "Minha Empresa" — assim ele já consegue cadastrar
 * produtos e anunciar. `isDraft` indica que faltam os dados do CNPJ.
 */
export const useCompany = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/companies/me");
      setCompany(response?.data?.data || null);
    } catch (error) {
      // 404 = usuário sem empresa (admin/power user): segue sem empresa.
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { company, setCompany, loading, refresh };
};
